module.exports = __webpack_public_path__ + "img/_map_fr_chicoutimi.fd98a00a.jpg";